import { useEffect, useState } from 'react'
import SurfaceObsAPI, {ElevatedObsAPI} from './SurfaceObsAPI'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMETARData } from './METAR/METARAPI'
import { fetchTAFData } from './TAF/TAFAPI'
import fetchAIRMETData from './AIRMET/AIRMETAPI'
import getActiveEvents, {
  getActiveEventsAuto,
} from '../Components/Alerting/AlertingSlice/getActiveAlerts'
import fetchSIGMETData from './SIGMET/SIGMETAPI'
import fetchPIREPData from './PIREP/PIREPAPI'
import { RootState } from '../store'
import NetworkData from '../interfaces/networkData'
import { getAllEvents } from '../menus/SlideOverDialog/SlideOverDialogEvents'
import { EventParser } from '../utils/ALERTUtils'
import { getUniqueSensorTypes, SurfaceObsSensors } from '../utils/SurfaceObsUtils'
import { useSlideOverDialogContext } from '../menus/SlideOverDialog/SlideOverDialogContext'
import useErrorStatus from '../hooks/UseErrorStatus'
import {
  deselectMenuItemById,
} from '../menus/SideNavigation/SideNavigationSlice'
import useAlertSetting from '../Components/Alerting/useAlertSetting'
import { pollingIntervals } from '../services/RequestTimeouts'
import { MenuLabels } from '../constants/MenuLabels'
import { ErrorTimeouts } from '../constants/ErrorTimeouts'
import { useInterval } from '../hooks/useInterval'
import useTWSMapContext from '../hooks/UseTWSContext'
import {
  useSensorEventContext,
  getActiveSensorEventsID,
} from '../utils/SensorAlertsUtils'
import { setAlertingNotification } from '../Components/Alerting/AlertingSlice/AlertingSlice'

const NetworkAdapter = ({ selectedSideNav, setnetworkData }) => {
  const dispatch = useDispatch()
  const { addAlertSideNav } = useAlertSetting()
  const { latitude, longitude } = useSelector(
    (state) => state.user.defaultLocation
  )
  const currProfile = useSelector((state: RootState) => state.user.thresholdProfile)
  const currThresholdUnit = useSelector((state: RootState) => state.user.thresholdUnits)
  
  const alertNotification = useSelector(
    (state) => state.alert.callNetworkAdapter
  )
  const selectedItems = useSelector(
    (state: RootState) => state.sideNav.selectedItems
  )

  const [surfaceObsData, setSurfaceObsData] = useState<NetworkData[]>([])
  const [metarData, setMetarData] = useState<NetworkData[]>([])
  const [tafData, setTafData] = useState<NetworkData[]>([])
  const [airmetData, setAirmetData] = useState<NetworkData[]>([])
  const [alertData, setAlertData] = useState<NetworkData[]>([])
  const [sigmetData, setSigmetData] = useState<NetworkData[]>([])
  const [pirepData, setPirepData] = useState<NetworkData[]>([])
  const [eventsData, setEventsData] = useState<NetworkData[]>([])
  const [eventsbeforeAlertData, seteventsbeforeAlertData] = useState<NetworkData[]>([])
  const [elevatedObsData, setelevatedObsData] = useState<NetworkData[]>([])

  const errorStatusHook = useErrorStatus()
  const {
    surfaceObsRefresh,
    airmetRefresh,
    sigmetRefresh,
    metarRefresh,
    tafRefresh,
    pirepRefresh,
    alertRefresh,
  } = pollingIntervals // intervals stored in RequestTimeouts.ts
  const { setSurfaceSensors, setElevatedSensors, setActiveMonitor, setLoadingStateForDialog } = useSlideOverDialogContext()
  const { removeFromTWS } = useTWSMapContext()
  const { activeEventSensorId, setActiveEventsSensors } =
    useSensorEventContext()
  //intervals
  const [surfaceObsInterval, setSurfaceObsInterval] =
    useState<number>(surfaceObsRefresh)
  const [elevatedObsInterval, setElevatedObsInterval] =
    useState<number>(surfaceObsRefresh)
  const [metarInterval, setMetarInterval] = useState<number>(metarRefresh)
  const [tafInterval, setTafInterval] = useState<number>(tafRefresh)
  const [pirepInterval, setPirepInterval] = useState<number>(pirepRefresh)
  const [sigmetInterval, setSigmetInterval] = useState<number>(sigmetRefresh)
  const [airmetInterval, setAirmetInterval] = useState<number>(airmetRefresh)
  const [alertInterval, setAlertInterval] = useState<number>(alertRefresh)

  const surfaceObsController = new AbortController()
  const metarController = new AbortController()
  const tafController = new AbortController()
  const pirepController = new AbortController()
  const sigmentController = new AbortController()
  const airmetController = new AbortController()
  const elevatedSensorsController = new AbortController()

  useEffect(() => {
    setSurfaceObsData([])
    setMetarData([])
    setTafData([])
    setAirmetData([])
    setSigmetData([])
    setPirepData([])
    setnetworkData([])
    setelevatedObsData([])
  }, [latitude])

  useEffect(() => {
    if (!selectedItems.includes(MenuLabels.PIREPS)) {
      setPirepData([])
    }
    if (!selectedItems.includes(MenuLabels.TAFS)) {
      setTafData([])
    }
    if (!selectedItems.includes(MenuLabels.GAIRMETS)) {
      setAirmetData([])
    }
    if (!selectedItems.includes(MenuLabels.SIGMETS)) {
      setSigmetData([])
    }
    if (!selectedItems.includes(MenuLabels.METARS)) {
      setMetarData([])
    }
  }, [selectedItems])

  useEffect(() => {
    fetchAlertData()
  }, [])

  useEffect(() => {
    setnetworkData([
      ...surfaceObsData,
      ...metarData,
      ...tafData,
      ...airmetData,
      ...alertData,
      ...sigmetData,
      ...pirepData,
      ...eventsData,
      ...eventsbeforeAlertData,
      ...elevatedObsData
    ])
  }, [
    alertData,
    surfaceObsData,
    metarData,
    tafData,
    airmetData,
    sigmetData,
    pirepData,
    elevatedObsData
  ])

  useEffect(() => {
    const fetchNetworkData = async () => {
      if (selectedItems.includes(MenuLabels.SURFACEOBS)) {
        refreshSurfaceObsData()
      } else if (!selectedItems.includes(MenuLabels.SURFACEOBS)) {
        setSurfaceObsData([])
        clearInterval(surfaceObsInterval)
        surfaceObsController.abort()
      }

      if (selectedItems.includes(MenuLabels.METARS)) {
        refreshMetarData()
      } else if (!selectedItems.includes(MenuLabels.METARS)) {
        setMetarData([])
        clearInterval(metarInterval)
        metarController.abort()
      }

      if (selectedItems.includes(MenuLabels.TAFS)) {
        refreshTafData()
      } else if (!selectedItems.includes(MenuLabels.TAFS)) {
        setTafData([])
        clearInterval(tafInterval)
        tafController.abort()
      }

      if (selectedItems.includes(MenuLabels.GAIRMETS)) {
        refreshAirmetData()
      } else if (!selectedItems.includes(MenuLabels.GAIRMETS)) {
        setAirmetData([])
        clearInterval(airmetInterval)
        airmetController.abort()
      }

      if (selectedItems.includes(MenuLabels.SIGMETS)) {
        refreshSigmetData()
      } else if (!selectedItems.includes(MenuLabels.SIGMETS)) {
        setSigmetData([])
        clearInterval(sigmetInterval)
        sigmentController.abort()
      }

      if (selectedItems.includes(MenuLabels.PIREPS)) {
        refreshPirepData()
      } else if (!selectedItems.includes(MenuLabels.PIREPS)) {
        setPirepData([])
        clearInterval(pirepInterval)
        pirepController.abort()
      }
      
      if (selectedItems.includes(MenuLabels.ELEVATED_OBS)) {   
        refreshElevatedObsData()
      } else if (!selectedItems.includes(MenuLabels.ELEVATED_OBS)) {
        setelevatedObsData([])
        clearInterval(elevatedObsInterval)
        elevatedSensorsController.abort()
      }
    }
    fetchNetworkData()

    return () => {
        surfaceObsController.abort(),
        metarController.abort(),
        tafController.abort(),
        airmetController.abort(),
        sigmentController.abort(),
        pirepController.abort()
        elevatedSensorsController.abort()
    }
  }, [selectedItems, latitude, currThresholdUnit])

  useEffect(() => {
    setnetworkData([
      ...surfaceObsData,
      ...metarData,
      ...tafData,
      ...airmetData,
      ...alertData,
      ...sigmetData,
      ...pirepData,
      ...eventsData,
      ...eventsbeforeAlertData,
      ...elevatedObsData
    ])
  }, [
    surfaceObsData,
    metarData,
    tafData,
    airmetData,
    sigmetData,
    pirepData,
    eventsData,
    eventsbeforeAlertData,
    elevatedObsData
  ])

  const refreshSurfaceObsData = () => {
    const { signal } = surfaceObsController
    setLoadingStateForDialog(true)
    SurfaceObsAPI(latitude, longitude, signal, surfaceObsController, currProfile)
      .then((data) => {
        setSurfaceObsData(data)
        getActiveSensorEventsID().then((eventData) => {
          setActiveEventsSensors(eventData)
          let [monitorBoolean, currProducts] = getUniqueSensorTypes(data, eventData)
          setSurfaceSensors(currProducts)
          setActiveMonitor(monitorBoolean)
        })
        if (!data.length) {
          if(!selectedItems.includes(MenuLabels.ELEVATED_OBS)) removeFromTWS(MenuLabels.SURFACEOBS)
          errorStatusHook.addMessage(
            'No sensors available at this location',
            400,
            'info',
            false
          )
          dispatch(deselectMenuItemById(MenuLabels.SURFACEOBS))
        }
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (surfaceObsRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
      })
      .finally(() => {
        setLoadingStateForDialog(false)
      })
  }

  const refreshMetarData = () => {
    const { signal } = metarController
    fetchMETARData(latitude, longitude, metarController, signal)
      .then((data) => {
        setMetarData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (metarRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById(MenuLabels.METARS))
      })
  }

  const refreshTafData = () => {
    const { signal } = tafController
    fetchTAFData(latitude, longitude, tafController, signal)
      .then((data) => {
        setTafData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (tafRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById(MenuLabels.TAFS))
      })
  }

  const refreshPirepData = () => {
    const { signal } = pirepController
    fetchPIREPData(latitude, longitude, pirepController, signal)
      .then((data) => {
        setPirepData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (pirepRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById(MenuLabels.PIREPS))
      })
  }

  const refreshAirmetData = () => {
    const { signal } = airmetController
    fetchAIRMETData(latitude, longitude, airmetController, signal)
      .then((data) => {
        setAirmetData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            '. Will retry in ' +
            (airmetRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById(MenuLabels.GAIRMETS))
      })
  }

  const refreshSigmetData = () => {
    const { signal } = sigmentController
    fetchSIGMETData(latitude, longitude, sigmentController, signal)
      .then((data) => {
        setSigmetData(data)
      })
      .catch((error) => {
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (sigmetInterval / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
        dispatch(deselectMenuItemById('aviation-sigmet'))
      })
  }

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.SURFACEOBS)) {
      refreshSurfaceObsData()
    }
  }, surfaceObsInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.METARS)) {
      refreshMetarData()
    }
  }, metarInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.TAFS)) {
      refreshTafData()
    }
  }, tafInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.PIREPS)) {
      refreshPirepData()
    }
  }, pirepInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.GAIRMETS)) {
      refreshAirmetData()
    }
  }, airmetInterval)

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.SIGMETS)) {
      refreshSigmetData()
    }
  }, sigmetInterval)

  useInterval(async () => {
    await fetchAlertData()
  }, alertInterval)

  const fetchAlertData = async () => {
    try {
      //Fetch Alerts data
      const [alertData, eventCount] = await getActiveEventsAuto()
      var sensorAlerts = []
      var monitorAlertMapping = {}
      for(let alert of alertData){          
        if(alert?.properties?.alerts?.length > 0 ) sensorAlerts.push(alert)
        else{ 
          let triggerEvent = alert?.properties?.triggerEvent
          if(!(triggerEvent in monitorAlertMapping)) monitorAlertMapping[triggerEvent] = []
          monitorAlertMapping[triggerEvent].push(alert)
        }
      }        
      setAlertData(sensorAlerts)

      //Fetch Monitor data
      const monitors = await getAllEvents()
      const parsedMonitorData = EventParser(monitors)    
      var monitorData = []
      for(let monitor of parsedMonitorData){
        let monitorName = monitor?.properties?.eventName
        monitor?.properties && 
          (monitor.properties["activeModelAlert"] = (monitorAlertMapping[monitorName]?.length ?? 0) > 0);
        monitor?.properties && 
          (monitor.properties["modelAlerts"] = monitorAlertMapping[monitorName] || []);
        monitorData.push(monitor)
      }
      setEventsData(monitorData) 
      dispatch(setAlertingNotification([alertData, eventCount]))
    } catch (error) {
      console.log(error);
      errorStatusHook.addMessage(
        "Alerting can't be accessed. Please check your subscription and try again.",
        400,
        'error',
        false,
        ErrorTimeouts.GENERAL
      )
    }
  }

  const refreshElevatedObsData = () => {  
    const { signal } = elevatedSensorsController
    setLoadingStateForDialog(true)
    ElevatedObsAPI(latitude, longitude, signal, elevatedSensorsController)
      .then((data) => {        
        setelevatedObsData(data)
        getActiveSensorEventsID().then((eventData) => {
          setActiveEventsSensors(eventData)
          let [monitorBoolean, currProducts] = getUniqueSensorTypes(data, eventData)
          setElevatedSensors(currProducts)
          setActiveMonitor(monitorBoolean)
        })
        if (!data.length) {
          //if(!selectedItems.includes(MenuLabels.SURFACEOBS)) removeFromTWS(MenuLabels.SURFACEOBS)
          errorStatusHook.addMessage(
            'No sensors available at this location',
            400,
            'warning',
            false
          )
          //dispatch(deselectMenuItemById(MenuLabels.ELEVATED_OBS))
        }
      })
      .catch((error) => {                
        errorStatusHook.addMessage(
          error.message +
            ' Will retry in ' +
            (surfaceObsRefresh / 60000).toString() +
            ' minutes.',
          400,
          'error',
          false
        )
      })
      .finally(() => {
        setLoadingStateForDialog(false)
      })
  }

  useInterval(() => {
    if (selectedItems.includes(MenuLabels.ELEVATED_OBS)) {
      refreshElevatedObsData()
    }
  }, elevatedObsInterval)
}

export default NetworkAdapter
